import { Component, EventEmitter, Input, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';

export interface TableColumn {
  field: string;
  header: string;
  width?: string;
  align?: 'left' | 'center' | 'right';
}

@Component({
  selector: 'app-table-search',
  templateUrl: './table-search.component.html',
  styleUrls: ['./table-search.component.css']
})
export class TableSearchComponent {
  @Input() columns: TableColumn[] = [];
  @Input() data: any[] = [];
  @Input() totalRecords: number = 0;
  @Input() lazy = true;
  @Input() rows = 10;
  @Input() showSearch = true;
  @Input() showDetails = false;
  @Input() showEdit = false;
  @Input() showDelete = false;
  @Input() customAction: TemplateRef<any> | null = null;

  @Output() onSearch = new EventEmitter<string>();
  @Output() onClear = new EventEmitter<void>();
  @Output() onDetails = new EventEmitter<any>();
  @Output() onEdit = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onLazyLoad = new EventEmitter<TableLazyLoadEvent>();

  searchValue: string = '';
  selectedRows: any[] = [];
  totalRecordss: number = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] || changes['totalRecords']) {
      this.totalRecordss = this.totalRecords > 0 ? this.totalRecords : (this.data?.length ?? 0);
    }
  }
  constructor(){
  }
  get globalFilterFields(): string[] {
    return this.columns.map(c => c.field);
  }

  handleSearch() {
    this.onSearch.emit(this.searchValue);
  }

  clearSearch() {
    this.searchValue = '';
    this.selectedRows = [];
    this.onClear.emit();
  }

  details(row: any) {
    this.onDetails.emit(row);
  }

  edit(row: any) {
    this.onEdit.emit(row);
  }

  delete(row: any) {
    this.onDelete.emit(row);
  }

  lazyLoad(event: TableLazyLoadEvent) {
    this.onLazyLoad.emit(event);
  }
}
